<template>
  <v-card :loading="loading" flat>
    <div class="pa-4">
      <div
        v-if="false && tabs <= 1"
        class="large-12 medium-12 small-12 filezone"
      >
        <input
          id="files"
          ref="files"
          multiple
          type="file"
          @change="handleFilesUpload()"
        />
        <p class="mt-2 text-center">
          <i class="fa fa-cloud-upload-alt text-primary fa-5x d-block"></i>
          فایل مورد نظر را اینجا بکشید ورها کنید.<br />یا برای آپلود فایل خود
          اینجا کلیک کنید.
        </p>
      </div>
      <template v-else>
        <detect-file-uploading @change="handleFilesUpload" />
        <video-upload-handler
          v-show="videoFiles?.length > 0 && tabs == 2"
          onChange
          v-model="videoFiles"
          @fetch="reloadByUpload"
        />
      </template>
      <upload-status-card ref="statusCard"></upload-status-card>

      <v-container fluid>
        <v-row class="my-3">
        <v-col
          v-for="(file, key) in files"
          :key="key"
          class="d-flex child-flex"
          cols="6" sm="4" md="2" lg="2" 
        >
          <div class="upload-preview-wrapper">
            
            <div v-if="file.type.indexOf('image') > -1">
              <v-img
                :ref="'preview' + parseInt(key)"
                :style="{ opacity: loadingValue[key] > 25 ? loadingValue[key] / 100 : '0.3' }"
                aspect-ratio="1"
                max-height="120" 
                contain
                class="rounded border grey lighten-4"
              >
                <v-btn
                  icon
                  x-small
                  color="white"
                  class="red mt-1 mr-1 float-right"
                  @click="removeFile(key)"
                >
                  <v-icon size="16">mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-img>
            </div>

            <div v-else>
              <v-img
                :style="{ opacity: loadingValue[key] > 25 ? loadingValue[key] / 100 : '0.3' }"
                height="120"
                width="120"
                contain
                class="rounded border grey lighten-4 mx-auto"
                :src="file.type.indexOf('audio') > -1 ? 'media/music.webp' : 'media/file.svg'"
              >
                <v-btn
                  icon
                  x-small
                  color="white"
                  class="red mt-1 mr-1 float-right"
                  @click="removeFile(key)"
                >
                  <v-icon size="16">mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-img>
            </div>
            
            <v-progress-linear
              v-if="loadingValue[key] < 100"
              height="4"
              :color="loadingValue[key] === 100 ? 'green' : 'blue'"
              :value="loadingValue[key]"
              class="mt-1"
            />
          </div>
        </v-col>

        </v-row>
      </v-container>

      <div v-if="files.length > 0" class="mt-4 p-3 blue-grey lighten-5 rounded-lg">
  <v-row align="center">
    
    <!-- اگر شرط ادمین برای سایز را نیاز دارید اینجا قرار می‌گیرد -->
    <v-col cols="12" md="3" v-if="coreUser.username === 'tt1' && coreUser.id === 4">
      <v-text-field
        clearable
        outlined
        dense
        hide-details
        label="سایز"
        list="sizes"
        prepend-inner-icon="mdi-image-size-select-large"
        background-color="white"
        @input="getBracket($event)"
      />
      <datalist id="sizes">
        <option v-for="item in cats" :key="'s-'+item" :value="item">{{ item }}</option>
      </datalist>
    </v-col>

    <v-col cols="12" :md="coreUser.username === 'tt1' && coreUser.id === 4 ? 6 : 8">
      <v-text-field
        clear-icon="mdi-close-circle-outline"
        clearable
        outlined
        dense
        hide-details
        label="نام دسته"
        list="groups"
        prepend-inner-icon="fa fa-pencil-alt"
        background-color="white"
        @input="getName($event)"
      />
      <!-- این دیتالیست لیست دسته‌بندی‌ها را به اینپوت بالا متصل می‌کند -->
      <datalist id="groups">
        <option v-for="item in cats" :key="'g-'+item" :value="item">{{ item }}</option>
      </datalist>
    </v-col>

    <v-col cols="12" :md="coreUser.username === 'tt1' && coreUser.id === 4 ? 3 : 4">
      <v-btn
        v-status="'file_store'"
        block
        class="btn-upload rounded-lg"
        :loading="loading"
        height="40"
        @click="submitFiles()"
      >
        <span class="fa fa-upload mr-2"></span>
        ثبت
      </v-btn>
    </v-col>

  </v-row>
</div>

      <custom-tabs
        v-model="tabs"
        :tab-items="[
          { text: 'تصاویر', icon: 'image', value: 'photo' },
          { text: 'فایل‌ها', icon: 'file', value: 'files' },
          { text: 'ویدئو', icon: 'video', value: 'video' },
          { text: 'صدا', icon: 'voicemail', value: 'sound' },
        ]"
        grow
      >
        <template v-slot:staticItems>
          <!-- تب تصاویر -->
          <v-tab-item class="mx-0 px-0 py-5">
            <v-container
              class="rounded mx-0 py-0 px-0"
              fluid
              style="
                background: #f8f8fa;
                max-height: 480px;
                overflow-y: scroll;
                position: relative;
              "
            >
              <v-row
                class="px-md-13 mx-auto justify-content-between"
                style="
                  position: sticky;
                  left: 0;
                  right: 0;
                  top: 0;
                  z-index: 10;
                  background-color: white;
                "
              >
                <v-col cols="5" md="4">
                  <v-checkbox
                    label="انتخاب همه"
                    @change="selectAll($event)"
                  ></v-checkbox>
                </v-col>
                <v-col cols="3" md="4">
                  <v-btn
                    v-if="selectedDl.length > 0"
                    :loading="loading"
                    class="btn-delete float-left"
                    @click="deleteAllFn"
                  >
                    <span class="fa fa-trash-alt ml-1"></span>
                    حذف
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="search"
                    :items="cats"
                    :loading="loading"
                    class="rounded-lg mt-md-2 mt-0"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hide-details
                    label="جستجو"
                    outlined
                    @change="callSearch"
                  />
                </v-col>
              </v-row>

              <v-card
                v-if="!loading && img.length === 0"
                flat
                class="text-center py-10 transparent"
              >
                <v-icon size="64" color="grey lighten-1"
                  >mdi-image-outline</v-icon
                >
                <v-card-title
                  class="text-center d-block text-h6 grey--text text--darken-2"
                >
                  فایل عکسی یافت نشد!
                </v-card-title>
                <v-card-subtitle class="grey--text">
                  برای افزودن تصویر از قسمت آپلود فایل استفاده نمایید
                </v-card-subtitle>
              </v-card>

              <!-- کلاس justify-content-around برای جلوگیری از وسط چین شدن حذف شد -->
              <v-row class="my-3 mt-5 pt-5 mx-0 px-0" v-else>
                <v-col
                  v-for="item in img"
                  :key="item.id"
                  class="d-flex child-flex p-1 bg-white mx-md-1 mx-0 mb-2 rounded shadow-lg position-relative"
                  cols="4"
                  md="2"
                  @click="maximizeMe(item.full_path)"
                >
                  <v-img
                    :src="item.full_path"
                    aspect-ratio="1"
                    class="rounded img-thumbnail clssbg"
                  >
                    <div
                      class="d-flex justify-start align-start mt-0 w-100 cover pa-0 rounded"
                    >
                      <v-checkbox
                        :key="item.full_path"
                        v-model="selectedDl"
                        :value="item.id"
                        class="ma-0 pa-0"
                        multiple
                        @click.stop
                      />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            class="ma-0 pa-0"
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="downloadFile(item.full_path)"
                            >mdi-download</v-icon
                          >
                        </template>
                        <span>دانلود</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            class="ma-0 pa-0"
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="deleteGeneric(item.id, 'image')"
                            >mdi-trash-can-outline</v-icon
                          >
                        </template>
                        <span>حذف</span>
                      </v-tooltip>
                    </div>
                  </v-img>
                </v-col>
                <v-col cols="12">
                  <v-card
                    v-if="
                      !loading && !isLastPage && !getError && next_page !== null
                    "
                    v-intersect="onIntersect"
                    flat
                  >
                    <atom-spinner
                      :animation-duration="1500"
                      :size="100"
                      class="mx-auto"
                      color="indigo"
                    ></atom-spinner>
                  </v-card>
                </v-col>
              </v-row>
              <p id="dl" ref="dl"></p>
              <atom-spinner
                v-if="loading && img.length > 0"
                :animation-duration="1500"
                :size="100"
                class="mx-auto"
                color="indigo"
              ></atom-spinner>
            </v-container>
          </v-tab-item>

          <!-- تب فایل ها -->
          <v-tab-item class="mx-0 px-0 py-5">
            <v-card
              v-if="!loading && misc.length === 0"
              flat
              class="text-center py-10 transparent"
            >
              <v-icon size="64" color="grey lighten-1"
                >mdi-file-document-outline</v-icon
              >
              <v-card-title
                class="text-center d-block text-h6 grey--text text--darken-2"
              >
                سندی یافت نشد!
              </v-card-title>
              <v-card-subtitle class="grey--text">
                برای افزودن فایل از قسمت آپلود فایل استفاده نمایید
              </v-card-subtitle>
            </v-card>

            <v-container
              v-if="misc.length > 0"
              class="rounded"
              fluid
              style="background: #f8f8fa"
            >
              <div class="d-flex px-13 justify-content-between">
                <v-checkbox
                  label="انتخاب همه"
                  @change="selectAll($event)"
                ></v-checkbox>
                <v-btn
                  v-if="selectedFile.length > 0"
                  :loading="loading"
                  class="btn-delete"
                  @click="deleteAllFn"
                >
                  <span class="fa fa-trash-alt ml-1"></span>
                  حذف
                </v-btn>
              </div>

              <!-- کلاس justify-content-around حذف شد -->
              <v-row class="my-3 mx-0 px-0">
                <v-col
                  v-for="item in misc"
                  :key="item.id"
                  class="mx-2 my-1 rounded position-relative"
                  cols="4"
                  md="2"
                  lg="2"
                  sm="3"
                >
                  <div>
                    <div
                      class="d-flex justify-start align-center mt-0 w-100 cover pa-0 rounded"
                    >
                      <v-checkbox
                        v-model="selectedFile"
                        :value="item.id"
                        multiple
                      ></v-checkbox>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="success"
                            @click="downloadFile(item.full_path)"
                            >mdi-download</v-icon
                          >
                        </template>
                        <span>دانلود</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="error"
                            @click="deleteGeneric(item.id, 'file')"
                            >mdi-trash-can</v-icon
                          >
                        </template>
                        <span>حذف</span>
                      </v-tooltip>
                    </div>

                    <v-img 
                      :src="item.image_fileurl || item.full_path_image || getFileIcon(item.path)" 
                      width="120" 
                      height="120"
                      contain
                    >
                    <template v-slot:error>
                        <v-img 
                          :src="getValidImageSrc(item)" 
                          width="120" 
                          height="120" 
                          contain
                        ></v-img>
                      </template>                  
                    </v-img>

                    <v-list-item-title class="d-flex align-center">
                      <v-text-field
                        v-if="editingFileId === item.id"
                        outlined
                        dense
                        hide-details
                        height="15px"
                        class="mr-2"
                        style="max-width: 250px"
                        append-icon="mdi-close"
                        prepend-inner-icon="mdi-check"
                        v-model="editFileNameText"
                        :loading="loadingFileName === item.id"
                        :disabled="loadingFileName === item.id"
                        @click:prepend-inner="updateFileName(item)"
                        @click:append="editingFileId = null"
                        @click.stop
                      ></v-text-field>

                      <span v-else class="text-truncate" :title="item.title">
                        <v-icon
                          @click.stop="startEditFile(item)"
                          size="15"
                          class="ml-1"
                          color="primary"
                        >
                          mdi-pencil
                        </v-icon>
                        {{ item.title || item.name || "بدون نام" }}
                      </span>
                    </v-list-item-title>
                  </div>
                </v-col>
              </v-row>
              <p id="dl" ref="dl"></p>
            </v-container>
            <p id="dlFile" ref="dlFile"></p>
          </v-tab-item>

          <!-- تب ویدئو -->
          <v-tab-item class="mx-0 px-0 py-5">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon color="success" right>mdi-plus</v-icon>
                    افزودن با کد آی فرم
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <video-by-link />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-progress-linear v-if="upLoading" height="2" />

            <!-- اضافه شدن قالب استاندارد برای ویدیو یافت نشد -->
            <v-card
              v-if="
                !loading &&
                localVideos.length === 0 &&
                (!defaultVideos.data || defaultVideos.data.length === 0)
              "
              flat
              class="text-center py-10 transparent"
            >
              <v-icon size="64" color="grey lighten-1"
                >mdi-video-outline</v-icon
              >
              <v-card-title
                class="text-center d-block text-h6 grey--text text--darken-2"
              >
                ویدئویی یافت نشد!
              </v-card-title>
              <v-card-subtitle class="grey--text">
                برای افزودن ویدئو از قسمت آپلود استفاده نمایید
              </v-card-subtitle>
            </v-card>

            <v-row v-else>
              <v-col
                v-for="item in localVideos"
                :key="'loc-' + item.id"
                cols="12"
                lg="3"
                md="4"
                sm="6"
              >
                <video-selector-card
                  :video="item"
                  :is-local="true"
                  @delete="deleteGeneric(item.id, 'video')"
                  @copy="copyLink"
                  @download="downloadFile"
                  @open="openLink"
                />
              </v-col>

              <v-col
                v-for="item in defaultVideos.data"
                :key="'ap-' + item.id"
                cols="12"
                lg="3"
                md="4"
                sm="6"
              >
                <video-selector-card
                  :video="item"
                  :is-local="false"
                  @copy="copyLink"
                  @open="openLink"
                />
              </v-col>

              <v-col cols="12">
                <v-card
                  v-if="
                    !loading &&
                    tabs === 2 &&
                    (!Object.hasOwn(defaultVideos, 'next_page_url') ||
                      !!defaultVideos.next_page_url)
                  "
                  v-intersect="onVideoInt"
                  class="d-flex justify-center"
                  flat
                >
                  <atom-spinner
                    :animation-duration="1500"
                    :size="100"
                    class="mx-auto"
                    color="indigo"
                  ></atom-spinner>
                </v-card>
              </v-col>
            </v-row>
            <p id="dlVideo" ref="dlVideo"></p>
          </v-tab-item>

          <!-- تب صدا -->
          <v-tab-item class="mx-0 px-0 py-5">
            <v-card
              v-if="!loading && audios.length === 0"
              flat
              class="text-center py-10 transparent"
            >
              <v-icon size="64" color="grey lighten-1"
                >mdi-music-note-outline</v-icon
              >
              <v-card-title
                class="text-center d-block text-h6 grey--text text--darken-2"
              >
                فایل صوتی یافت نشد!
              </v-card-title>
              <v-card-subtitle class="grey--text">
                برای افزودن فایل صوتی از قسمت آپلود فایل استفاده نمایید
              </v-card-subtitle>
            </v-card>

            <v-row v-if="audios.length > 0" :disabled="loading" class="pa-2">
              <v-col cols="12" v-if="loading">
                <atom-spinner
                  :animation-duration="1500"
                  :size="100"
                  class="mx-auto"
                  color="indigo"
                ></atom-spinner>
              </v-col>
              <v-col
                cols="12"
                class="d-flex justify-space-between align-center"
              >
                <v-checkbox
                  label="انتخاب همه"
                  @change="selectAll($event)"
                  hide-details
                  class="mt-0"
                ></v-checkbox>

                <v-btn
                  v-if="selectedFile.length > 0"
                  :loading="loading"
                  class="btn-delete"
                  @click="deleteAllSound"
                >
                  <span class="fa fa-trash-alt ml-1"></span>
                  حذف
                </v-btn>
              </v-col>
              <v-col
                v-for="(audio, i) in audios"
                :key="i"
                cols="12"
                sm="6"
                md="3"
                lg="3"
              >
                <v-card :disabled="loading">
                  <v-card-text class="d-flex">
                    <div
                      class="d-flex justify-start align-center mt-0 w-100 cover pa-0 rounded"
                    >
                      <v-checkbox
                        v-model="selectedFile"
                        :value="audio.id"
                        multiple
                      ></v-checkbox>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="error"
                            class="mx-1"
                            @click="deleteGeneric(audio.id, 'audio')"
                            >mdi-trash-can</v-icon
                          >
                        </template>
                        <span>حذف</span>
                      </v-tooltip>
                    </div>
                  </v-card-text>

                  <audio-player
                    :title="audio?.title"
                    flat
                    :file="audio.full_path"
                    :id="audio.id"
                    @title-updated="audio.title = $event"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <atom-spinner
                  v-if="loading"
                  :animation-duration="1500"
                  :size="100"
                  class="mx-auto"
                  color="indigo"
                ></atom-spinner>
              </v-col>
            </v-row>
            <p id="dlSound" ref="dlSound"></p>
          </v-tab-item>
        </template>
      </custom-tabs>
    </div>

    <custom-popup
      v-model="showMax"
      :cons="{ title: 'نمایش عکس' }"
      close-on-confirm
    >
      <v-card>
        <image-show v-model="choosenImg" />
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import uploadStatusCard from "./uploadStatusCard.vue";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import VideoUploader from "@/view/components/UploadCenter/videoUploader/videoUploader.vue";
import VoiceGallery from "@/view/components/UploadCenter/voiceGallery/index.vue";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import { rbAxios } from "@/main";
import { AtomSpinner } from "epic-spinners";
import ImageShow from "@/view/components/UploadCenter/imageShow";
import { mapGetters } from "vuex";
import VideoByLink from "@/view/components/UploadCenter/videoUploader/videoByLink";
import VideoSelectorCard from "@/view/components/UploadCenter/videoUploader/videoSelectorCard";
import VideoUploadHandler from "@/view/components/UploadCenter/videoUploader/videoUploadHandler";
import DetectFileUploading from "./detectFileUploading";
import AudioPlayer from "./voiceGallery/components/audioPlayer.vue";

export default {
  name: "Uploader",

  components: {
    DetectFileUploading,
    VideoUploadHandler,
    VideoSelectorCard,
    VideoByLink,
    VideoUploader,
    ImageShow,
    TitleRibbon,
    PicSelector,
    AtomSpinner,
    AudioPlayer,
    uploadStatusCard,
  },

  props: {
    category: {
      type: String,
    },
  },

  data() {
    return {
      localVideos: [],
      bracket: null,
      loading: false,
      isLastPage: false,
      activeTab: 0,

      files: [],
      videoFiles: [],
      img: [],
      misc: [],
      cats: [],
      audios: [],
      erroredPic: 0,
      successPic: 0,
      categories: "",
      refresh: true,
      showMax: false,
      choosenImg: "",
      tabs: 0,
      loadingValue: [],
      getError: false,
      selectedDl: [],
      selectedFile: [],
      defaultVideos: {
        data: [],
      },
      isIntersecting: false,
      isLastPage: null,
      upLoading: false,
      next_page: 1,
      observer: null,
      previews: {},
      n: "",
      search: "",
      file_types: "",
      editingFileId: null,
      editFileNameText: "",
      loadingFileName: null,
    };
  },

  mounted() {
    if (this.$route.name === "uploadCenter") {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.next_page !== null) {
            if (this.tabs === 0) {
              this.observer.unobserve(this.$refs.dl);
              this.getImages();
            } else if (this.tabs === 1) {
              this.observer.unobserve(this.$refs.dlFile);
              this.getFiles();
            } else if (this.tabs === 2) {
              this.observer.unobserve(this.$refs.dlVideo);
              if (this.ribbon_can("upload_video_store")) this.getVideos(true);
              else this.getVideos();
              this.getLocalVideos();
            } else if (this.tabs === 3) {
              this.observer.unobserve(this.$refs.dlSound);
              this.getSound();
            }
          }
        });
      });

      this.getError = false;

      this.getImages();
      this.getFiles();
      if (this.ribbon_can("upload_video_store")) this.getVideos(true);
      else this.getVideos();
      this.getLocalVideos();
      this.getSound();
    }
  },

  computed: {
    ...mapGetters("ribbon", {
      coreUser: "user",
    }),
  },

  watch: {
    tabs(val, oldval) {
      this.selectedDl = [];
      this.selectedFile = [];
      if (val !== oldval) {
        this.resetState();
      }
      if (val === 0 && this.img.length === 0) {
        this.next_page = 1;
        this.getImages();
      }

      if (val === 1 && this.misc.length === 0) {
        this.next_page = 1;
        this.getFiles();
      }
      if (val === 2) {
        if (this.defaultVideos.data.length === 0) {
          if (this.ribbon_can("upload_video_store")) this.getVideos(true);
          else this.getVideos();
        }
        if (this.localVideos.length === 0) {
          this.next_page = 1;
          this.getLocalVideos();
        }
      }
      if (val === 3 && this.audios.length === 0) {
        this.next_page = 1;
        this.getSound();
      }
    },
    files(val) {
      val.forEach((item) => {
        this.file_types = item.type;

        if (item.type.startsWith("audio/")) {
          if (
            this.coreUser.username !== "tt1" &&
            Math.round(item.size / 1024) < 81920
          ) {
            this.$toast.success("فایل صدای شما با موفقیت خوانده شد.");
            this.tabs = 3;
          } else if (this.coreUser.username !== "tt1") {
            this.$toast.warning(
              "فایل صدای شما نمیتواند بیشتر از 80 مگابایت باشد.",
            );
          }
        } else if (item.type.startsWith("image/")) {
          if (
            this.coreUser.username !== "tt1" &&
            Math.round(item.size / 1024) > 5120
          ) {
            this.files.splice(val.indexOf(item), 1);
            this.$toast.warning(
              "عکس‌های با حجم بالای 5 مگابایت مورد قبول نیستند.",
            );
          }
        } else if (item.type.startsWith("video/")) {
          if (
            this.coreUser.username !== "tt1" &&
            Math.round(item.size / 1024) > 51200
          ) {
            this.files.splice(val.indexOf(item), 1);
            this.$toast.warning(
              "ویدیوهای با حجم بالای 50 مگابایت مورد قبول نیستند.",
            );
          }
        } else {
          if (
            this.coreUser.username !== "tt1" &&
            Math.round(item.size / 1024) > 51200
          ) {
            this.files.splice(val.indexOf(item), 1);
            this.$toast.warning(
              "فایل‌های با حجم بالای 50 مگابایت مورد قبول نیستند.",
            );
          }
        }
      });

      if (this.files.length > 20) {
        this.$toast.error("حداکثر 20 فایل/عکس میتوانید انتخاب کنید.");
        this.files.splice(0, this.files.length - 20);
      } else {
        this.loadingValue.fill(0);
        this.getImagePreviews();
      }
    },
  },
  methods: {
      refreshCurrentTab() {
        this.next_page = 1;
        this.loading = false;         
        this.$nextTick(() => {
          if (this.tabs === 0) { 
            this.img = []; 
            this.getImages(); 
          }
          else if (this.tabs === 1) { 
            this.misc = []; 
            this.getFiles(); 
          }
          else if (this.tabs === 2) { 
            this.localVideos = []; 
            this.getLocalVideos(); 
          }
          else if (this.tabs === 3) { 
            this.audios = []; 
            this.getSound(); 
          }
        });
      },
    getValidImageSrc(item) {
    if (item.image_fileurl) return item.image_fileurl;
    if (item.full_path_image) return item.full_path_image;

    const pathOrName = item.path || item.name || '';
    const icon = this.getFileIcon(pathOrName);
    if (icon) return icon;

    return this.getFileIcon(item.path); 
  },
    resetState() {
      this.isLastPage = false;
      this.next_page = 1;
      this.loading = false;
    },
    fetchDataForCurrentTab() {
      if (this.activeTab === 0) this.getImages();
      else if (this.activeTab === 2) this.getVideos();
      else if (this.activeTab === 3) this.getSounds();
      else if (this.activeTab === 1) this.getFiles();
    },

    startEditFile(file) {
      this.editFileNameText = file.title || file.name || "";
      this.editingFileId = file.id;
    },
    updateFileName(file) {
      if (!this.editFileNameText) return;

      this.loadingFileName = file.id;
      const local_url = this.$robotApi;

      this.$api
        .put(`${local_url}/files/update/${file.id}`, {
          title: this.editFileNameText,
        })
        .then((res) => {
          this.$toast.success("نام فایل با موفقیت بروزرسانی شد");
          file.title = this.editFileNameText;
          this.editingFileId = null;
        })
        .catch((err) => {
          this.$toast.error("خطا در بروزرسانی نام فایل");
        })
        .finally(() => {
          this.loadingFileName = null;
        });
    },
    callSearch() {
      this.next_page = 1;
      if (this.tabs === 0) {
        this.getImages();
      } else if (this.tabs === 1) {
        this.getFiles();
      } else if (this.tabs === 2) {
        if (this.ribbon_can("upload_video_store")) this.getVideos(true);
        else this.getVideos();
        this.getLocalVideos();
      } else if (this.tabs === 3) {
        this.getSound();
      }
    },
    openLink(url) {
      if (url) window.open(url, "_blank");
    },
    copyLink(url) {
      if (!url) return;
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$toast.success("لینک با موفقیت کپی شد.");
        })
        .catch(() => {
          this.$toast.error("کپی کردن لینک با خطا مواجه شد.");
        });
    },
    async deleteGeneric(id, type) {
      if (
        await this.$modal.yesNo("آیا از حذف آیتم انتخاب شده اطمینان دارید؟")
      ) {
        let Token = "Bearer " + localStorage.getItem("id_token");
        this.loading = true;
        const local_url = this.$robotApi;

        $.ajax({
          url: `${local_url}/files/${id}`,
          method: "DELETE",
          headers: { ACCEPT: "application/json", Authorization: Token },
          success: (res) => {
                    this.$toast.success("آیتم با موفقیت حذف شد");
                    if (this.$refs.statusCard) this.$refs.statusCard.getRemainingFiles();
                    
                    if (type === "image") {
                      this.img = this.img.filter(item => item.id !== id);
                    } else if (type === "file") {
                      this.misc = this.misc.filter(item => item.id !== id);
                    } else if (type === "video") {
                      this.localVideos = this.localVideos.filter(item => item.id !== id);
                    } else if (type === "audio") {
                      this.audios = this.audios.filter(item => item.id !== id);
                    }
          },
          error: () => {
            this.$toast.error("خطا در حذف آیتم.");
          },
          complete: () => {
            this.loading = false;
          },
        });
      }
    },
    getLocalVideos() {
      if (this.loading || this.next_page === null) return;
      this.loading = true;

      let Token = "Bearer " + localStorage.getItem("id_token");
      const local_url = this.$robotApi;

      $.ajax({
        url: `${local_url}/files`,
        headers: { ACCEPT: "application/json", Authorization: Token },
        data: {
          file_type: "video",
          paginate: 1,
          dir: "desc",
          page: this.next_page,
          category:
            this.search === "" || this.search === null
              ? undefined
              : this.search,
        },
        type: "GET",
        success: (data) => {
          const itemsData = data.data.items.data;
          this.localVideos =
            this.next_page === 1
              ? itemsData
              : [...this.localVideos, ...itemsData];

          if (data.data.items.next_page_url) {
            this.next_page = data.data.items.current_page + 1;
            this.$nextTick(() => {
              if (this.$refs.dlVideo) this.observer.observe(this.$refs.dlVideo);
            });
          } else {
            this.next_page = null;
            if (this.$refs.dlVideo) this.observer.unobserve(this.$refs.dlVideo);
          }
        },
        error: (err) => {
          this.next_page = null;
          if (this.$refs.dlVideo) this.observer.unobserve(this.$refs.dlVideo);
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    downloadFile(url) {
      if (!url) return;
      const a = document.createElement("a");
      a.href = url;
      a.download = url.split("/").pop() || "download";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getFileIcon(path) {
      if (!path) return "media/file.svg";

      const ext = path?.split(".").pop().toLowerCase();
      switch (ext) {
        case "doc":
        case "docx":
          return `media/doc.webp`;
        case "pdf":
          return `media/pdf.webp`;
        case "txt":
          return `media/txt.webp`;
        default:
          return "media/file.svg";
      }
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (Object.hasOwn(this.previews, this.files[i].name)) {
          this.$nextTick(() => {
            if (this.$refs["preview" + parseInt(i)])
              this.$refs["preview" + parseInt(i)][0].src =
                this.previews[this.files[i].name];
          });
          continue;
        }

        if (/\.(jpe?g|png|gif|svg)$/i.test(this.files[i].name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              if (this.$refs["preview" + parseInt(i)])
                this.$refs["preview" + parseInt(i)][0].src = reader.result;
              this.previews[this.files[i].name] = reader.result;
            }.bind(this),
            false,
          );
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function () {
            if (this.$refs["preview" + parseInt(i)])
              this.$refs["preview" + parseInt(i)][0].src = "/img/generic.png";
          });
        }
      }
    },
    getVideos(getDef = false) {
      if (this.upLoading || this.next_page === null) return;

      this.upLoading = true;
      this.$api
        .get(
          `${this.$qrApi}/user/aparat?${getDef ? "default=1&" : ""}page=${
            (this.defaultVideos.current_page || 0) + 1
          }`,
        )
        .then(({ data }) => {
          let lastImg = this.defaultVideos?.data || [];
          let temp = data.data;
          temp.data = lastImg.concat(temp.data);
          this.defaultVideos = temp;
        })
        .catch(({ response }) =>
          console.log("error in get default videos: ", response),
        )
        .finally(() => (this.upLoading = false));
    },
    handleFilesUpload(e) {
      this.files = [];
      this.videoFiles = [];

      if (["image", "file"].includes(e.type)) {
        this.tabs = e.type === "image" ? 0 : 1;
        if (e.files instanceof Array)
          for (let i = 0; i < e.files.length; i++) {
            this.files.push(e.files[i]);
          }
        else this.files.push(e.files);

        this.$nextTick(() => {
          this.getImagePreviews();
        });
      } else {
        this.$set(this, "tabs", 2);
        this.$set(this, "videoFiles", e.files);

        this.$forceUpdate();
      }
    },
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.img) && !this.isLastPage)
          this.getImages();
      });
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },
    getImages() {
      if (this.loading || this.next_page === null) return;

      this.loading = true;
      let Token = "Bearer " + localStorage.getItem("id_token");
      const local_url = this.$robotApi;

      $.ajax({
        url: `${local_url}/files`,
        headers: { ACCEPT: "application/json", Authorization: Token },
        data: {
          file_type: "image",
          paginate: 1,
          dir: "desc",
          page: this.next_page,
          category:
            this.search === "" || this.search === null
              ? undefined
              : this.search,
        },
        type: "GET",
        success: (data) => {
          this.cats = data.data.categories;
          const itemsData = data.data.items.data;
          this.img =
            this.next_page === 1 ? itemsData : [...this.img, ...itemsData];

          if (data.data.items.next_page_url) {
            this.next_page = data.data.items.current_page + 1;
            this.$nextTick(() => {
              if (this.$refs.dl) this.observer.observe(this.$refs.dl);
            });
          } else {
            this.next_page = null;
            if (this.$refs.dl) this.observer.unobserve(this.$refs.dl);
          }
        },
        error: (err) => {
          this.getError = true;
          this.next_page = null;
          if (this.$refs.dl) this.observer.unobserve(this.$refs.dl);
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    getSound() {
      if (this.loading || this.next_page === null) return;
      this.loading = true;

      let Token = "Bearer " + localStorage.getItem("id_token");
      const local_url = this.$robotApi;

      $.ajax({
        url: `${local_url}/files`,
        headers: { ACCEPT: "application/json", Authorization: Token },
        data: {
          file_type: "audio",
          paginate: 1,
          dir: "desc",
          page: this.next_page,
          category:
            this.search === "" || this.search === null
              ? undefined
              : this.search,
        },
        type: "GET",
        success: (data) => {
          const itemsData = data.data.items.data;
          this.audios =
            this.next_page === 1 ? itemsData : [...this.audios, ...itemsData];

          if (data.data.items.next_page_url) {
            this.next_page = data.data.items.current_page + 1;
            this.$nextTick(() => {
              if (this.$refs.dlSound) this.observer.observe(this.$refs.dlSound);
            });
          } else {
            this.next_page = null;
            if (this.$refs.dlSound) this.observer.unobserve(this.$refs.dlSound);
          }
        },
        error: (err) => {
          this.next_page = null;
          if (this.$refs.dlSound) this.observer.unobserve(this.$refs.dlSound);
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    getFiles() {
      if (this.loading || this.next_page === null) return;
      this.loading = true;

      let Token = "Bearer " + localStorage.getItem("id_token");
      const local_url = this.$robotApi;

      $.ajax({
        url: `${local_url}/files`,
        headers: { ACCEPT: "application/json", Authorization: Token },
        data: {
          file_type: "file",
          paginate: 1,
          dir: "desc",
          page: this.next_page,
          category:
            this.search === "" || this.search === null
              ? undefined
              : this.search,
        },
        type: "GET",
        success: (data) => {
          const itemsData = data.data.items.data;
          this.misc =
            this.next_page === 1 ? itemsData : [...this.misc, ...itemsData];

          if (data.data.items.next_page_url) {
            this.next_page = data.data.items.current_page + 1;
            this.$nextTick(() => {
              if (this.$refs.dlFile) this.observer.observe(this.$refs.dlFile);
            });
          } else {
            this.next_page = null;
            if (this.$refs.dlFile) this.observer.unobserve(this.$refs.dlFile);
          }
        },
        error: (err) => {
          this.next_page = null;
          if (this.$refs.dlFile) this.observer.unobserve(this.$refs.dlFile);
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    async removeFromGallery(key) {
      if (
        await this.$modal.yesNo("آیا از حذف مورد انتخاب شده اطمینان دارید؟")
      ) {
        let Token = "Bearer " + localStorage.getItem("id_token");
        this.loading = true;
        const vm = this;
        const local_url = this.$robotApi;
        $.ajax({
          url: `${local_url}/files/${key}`,
          method: "DELETE",
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
          success: (res) => {
            vm.$toast.success("آیتم با موفقیت حذف شد");
            vm.next_page = 1;
            vm.getImages();
            if (vm.$refs.statusCard) vm.$refs.statusCard.getRemainingFiles();
          },
          complete: () => {
            this.loading = false;
          },
        });
      }
    },
    async removeFromSound(key) {
      if (
        await this.$modal.yesNo("آیا از حذف مورد انتخاب شده اطمینان دارید؟")
      ) {
        let Token = "Bearer " + localStorage.getItem("id_token");
        this.loading = true;
        const vm = this;
        const local_url = this.$robotApi;
        $.ajax({
          url: `${local_url}/files/${key}`,
          method: "DELETE",
          headers: {
            ACCEPT: "application/json",
            Authorization: Token,
          },
         success: (res) => {
  vm.$toast.success("فایل صوتی شما با موفقیت حذف شد");
  if (vm.$refs.statusCard) vm.$refs.statusCard.getRemainingFiles();
  
  // حذف محلی از آرایه صداها
  this.audios = this.audios.filter(item => item.id !== key);
          },
          complete: () => {
            this.loading = false;
          },
        });
      }
    },
    async deleteAllSound() {
      if (
        await this.$modal.yesNo("آیا از حذف مورد انتخاب شده اطمینان دارید؟")
      ) {
        this.loading = true;
        rbAxios
          .delete("/files/mass/delete", {
            params: {
              ids:
                this.selectedDl.length > 0
                  ? this.selectedDl
                  : this.selectedFile,
            },
          })
            .then((res) => {
              this.$toast.success("فایل های صوتی موردنظر با موفقیت حذف شدند.");
              const idsToDelete = this.selectedDl.length > 0 ? this.selectedDl : this.selectedFile;
              
              this.audios = this.audios.filter(item => !idsToDelete.includes(item.id));
              
              this.selectedDl = [];
              this.selectedFile = [];
              if (this.$refs.statusCard) this.$refs.statusCard.getRemainingFiles();
            })
          .catch(() => {
            this.$toast.error("حذف آیتم های موردنظر شما با خطا مواجه شد.");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    submitFiles(item = 0) {
      this.loading = true;

      let file_type = "";
      if (this.tabs == 0) file_type = "image";
      else if (this.tabs == 1) file_type = "file";
      else if (this.tabs == 3) file_type = "audio";
      else if (this.tabs == 2) file_type = "video";

      if (this.n === "") {
        this.$toast.error("نام دسته خودرا وارد کنید.");
        this.loading = false;
        this.getImagePreviews();
      } else {
        let formData = new FormData();
        if (this.coreUser.username === "tt1" && this.coreUser.id === 4) {
          formData.append("bracket", this.bracket ?? undefined);
        }
        formData.append("category", this.n);
        formData.append("file", this.files[item]);
        formData.append("type", "other");
        formData.append("file_type", file_type);
        const Token = localStorage.getItem("id_token");
        const local_url = this.$robotApi;
        $.ajax({
          url: `${local_url}/files`,
          type: "POST",
          data: formData,
          headers: {
            Authorization: Token,
            ACCEPT: "application/json",
          },
          xhr: () => {
            let xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener(
              "progress",
              (evt) => {
                if (evt.lengthComputable) {
                  this.loadingValue[item] = (evt.loaded / evt.total) * 100;
                  this.$forceUpdate();
                }
              },
              false,
            );
            return xhr;
          },
          contentType: false,
          processData: false,
        }).always((data) => {
          try {
            document
              .querySelectorAll("#imagess")
              [item].classList.add(
                data.status === true ? " " : "border-danger",
              );
            if (data.status !== true) this.erroredPic += 1;
          } catch (e) {}

          item++;
          if (data.status === true) this.successPic++;

          if (this.files.length > item) {
            this.submitFiles(item);
          } else {
            if (this.erroredPic <= 0) {
              this.files = []; // در اینجا چون آپلود موفق بوده لیست فایل‌های استیج پاک می‌شود
              this.categories = "";
              this.next_page = 1;
              this.resetState();

              if (this.tabs === 0) this.getImages();
              else if (this.tabs === 1) this.getFiles();
              else if (this.tabs === 2) this.getLocalVideos();
              else if (this.tabs === 3) this.getSound();

              if (this.$refs.statusCard)
                this.$refs.statusCard.getRemainingFiles();
              this.loading = false;
            } else {
              this.$nextTick(() => {
                this.$modal.error(
                  "خطا!",
                  "لظفا فایل‌های مشخص شده با کادر قرمز را حذف و با فایل درست جایگزین کنید و دوباره ثبت کنید.",
                );
                this.loading = false;
              });
              this.erroredPic = 0;
            }
          }
        });
      }
    },
    onVideoInt(entries, observer) {
      if (
        (entries[0].isIntersecting || !this.defaultVideos.data.length) &&
        (!Object.hasOwn(this.defaultVideos, "next_page_url") ||
          !!this.defaultVideos.next_page_url)
      )
        if (this.ribbon_can("upload_video_store")) this.getVideos(true);
        else this.getVideos();
    },
    selectAll(e) {
      if (!e) {
        if (this.tabs === 0) this.selectedDl = [];
        else if (this.tabs === 1 || this.tabs === 3) this.selectedFile = [];
      } else {
        if (this.tabs === 0) {
          this.selectedDl = this.img.map((item) => item.id);
        } else if (this.tabs === 1) {
          this.selectedFile = this.misc.map((item) => item.id);
        } else if (this.tabs === 3) {
          this.selectedFile = this.audios.map((item) => item.id);
        }
      }
    },
    async deleteAllFn() {
      if (
        await this.$modal.yesNo("آیا از حذف مورد انتخاب شده اطمینان دارید؟")
      ) {
        this.loading = true;
        rbAxios
          .delete("/files/mass/delete", {
            params: {
              ids:
                this.selectedDl.length > 0
                  ? this.selectedDl
                  : this.selectedFile,
            },
          })
            .then((res) => {
              this.$toast.success("آیتم‌های موردنظر با موفقیت حذف شدند.");
              const idsToDelete = this.selectedDl.length > 0 ? this.selectedDl : this.selectedFile;

              this.img = this.img.filter(item => !idsToDelete.includes(item.id));
              this.misc = this.misc.filter(item => !idsToDelete.includes(item.id));

              this.selectedDl = [];
              this.selectedFile = [];
              if (this.$refs.statusCard) this.$refs.statusCard.getRemainingFiles();
            })
          .catch(() => {
            this.$toast.error("حذف آیتم های موردنظر شما با خطا مواجه شد.");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    selectFile(e) {
      if (!e) {
        this.selectedFile = [];
      } else {
        this.misc.forEach((item) => {
          this.selectedFile.push(item.id);
        });
      }
    },
    getName(e) {
      this.n = e;
    },
    getBracket(e) {
      this.bracket = e;
    },
    maximizeMe(image) {
      this.showMax = true;
      this.choosenImg = image;
    },
    callImages() {
      this.next_page = null;
      this.getImages();
    },
    reloadByUpload() {
      this.defaultVideos = {
        data: [],
      };
    },
  },
};
</script>
<style>
.clssbg .v-input__slot {
  background-color: white !important;
}

.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}

.fa-pencil-alt {
  font-size: 12pt !important;
}

.border-danger {
  border: 2px solid #f44336 !important;
}

input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.filezone {
  outline: 3px dashed #163cd0;
  outline-offset: -3px;
  color: dimgray;
  padding: 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  background-color: #ddddeee0;
}

.filezone:hover {
  background: #ddddeee0;
}

.filezone p {
  font-size: 1.2em;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

.icon-cloud-up {
  color: #163cd0;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-1:hover {
  -webkit-line-clamp: 3;
}
.upload-thumb {
  height: 90px;
}
.cover {
  height: 30px;
  background: #d3d1d14d !important;
  border-radius: 5px !important;
}
</style>
